<template>
  <div class="bg-white text-left py-8 px-10">
    <div
      class="
        grid grid-cols-[7rem,auto]
        border-b-1 border-hex-E4E4E4
        pb-10
        text-base
      "
    >
      <div class="space-y-5 text-right">
        <p class="truncate">{{ $t("银行卡信息") }}：</p>
        <p>&nbsp;</p>
        <p>{{ $t("提现") }}：</p>
        <p>{{ $t("到账时间") }}：</p>
      </div>
      <div class="space-y-5" v-if="checkedCard">
        <p class="text-1.25rem">{{ checkedCard.name }}</p>
        <p class="flex items-center space-x-2">
          <span>{{ checkedCard.banktype.value }}</span>
          <span> ({{ maskCardNo(checkedCard.cardno) }}) </span>
        </p>
        <p class="text-1.3rem text-hex-F89600 pt-1">￥{{ withdrawalMoney }}</p>
        <p class="text-hex-F89600">{{ $t("预计次日24点前") }}</p>
      </div>
    </div>
    <!-- <div class="pt-6 grid grid-cols-[6.3rem,15rem,5rem] items-center">
      <p class="text-right">
        支付密码：
      </p>
      <p>
        <el-input v-model="pay_code" show-password></el-input>
      </p>
      <p class="text-sm text-hex-3298F0 pl-2">
        忘记密码?
      </p>
    </div> -->
    <div class="pt-6 grid grid-cols-[6.3rem,10rem]">
      <p>&nbsp;</p>
      <el-button type="warning" class="px-2" @click="confirm">{{
        $t("确认提现")
      }}</el-button>
    </div>
  </div>
</template>
<script>
import { onMounted, ref } from "@vue/composition-api";

export default {
  setup(props, ctx) {
    const radio = ref(1);
    const checked = ref(true);
    const addCard = () => {
      ctx.root.$router.push({
        name: "addCard",
      });
    };
    //确认银行卡信息
    const checkedCard = ref();
    onMounted(() => {
      checkedCard.value = JSON.parse(
        sessionStorage.getItem("checkedCardMessage")
      );
    });
    const disabled = ref(true);
    //银行卡加密
    const maskCardNo = (no) => {
      return "**** **** **** *** " + no.substr(no.length - 4);
    };
    const withdrawalMoney = ctx.root.$route.query.withdrawalMoney;
    const bankCard_id = ctx.root.$route.query.bankCard_id;
    //确认提现
    const confirm = async () => {
      ctx.root.$doing();
      const res = await ctx.root.$callapi("user/drawMoney", {
        money: withdrawalMoney,
        bankcard_id: bankCard_id,
      });
      ctx.root.$done();
      if (res && res.data) {
        await ctx.root.$loadUserInfo();
        await ctx.root.$toast(ctx.root.$t("提现申请提交成功，请耐心等待。"));
        await ctx.root.$router.push({ name: "Wallet" });
      }
    };
    return {
      radio,
      checked,
      addCard,
      withdrawalMoney,
      disabled,
      confirm,
      checkedCard,
      maskCardNo,
    };
  },
};
</script>
<style scoped lang="scss">

</style>
